import React from 'react';

interface ReportIssueButtonProps {
  jobId?: string | number;
  errorMessage?: string;
  className?: string;
}

const ReportIssueButton: React.FC<ReportIssueButtonProps> = ({ 
  jobId = '-', 
  errorMessage = '-',
  className = ''
}) => {
  const handleReportIssue = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    const newWindow = window.open('', '_blank');

    const email = "Support@wethaiinvest.com";
    const subject = encodeURIComponent(`แจ้งปัญหาการใช้งานเว็บช่อง`);
    
    // จัด Format อีเมลตามที่คุณกำหนด
    const body = encodeURIComponent(
      `⚠️ เจอปัญหาการใช้งาน: \n` +
      `1. รูปปัญหา: (กรุณาแนบรูปภาพในอีเมลนี้)\n` +
      `2. รายละเอียด: \n\n\n` +
      `3. (กรณีมีปัญหาเรื่องพอร์ต) ID พอร์ต: (เข้า "พอร์ตของฉัน" --> เข้าพอร์ตย่อย --> ดูตรง URL แล้ว copy ที่อยู่ด้านหลัง portfolio/ เช่น portfolio/PORTdrfC7NZHP3JW8WE2 ครับ)\n` +
      `\n--------------------------------\n` +
      `ข้อมูลเพิ่มเติมจากระบบ (ถ้ามี):\n` +
      `Job ID: ${jobId}\n` +
      `Error Message: ${errorMessage}`
    );

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`;

    if (newWindow) {
      newWindow.location.href = gmailUrl;
    } else {
      alert("กรุณาอนุญาตให้เว็บไซต์เปิด Pop-up เพื่อแจ้งปัญหาทางอีเมล");
    }
  };

  return (
    // ใช้ relative และ group สำหรับทำ Tooltip
    <div className={`relative group flex justify-center w-full ${className}`}>
      
      {/* --- ส่วนของ Tooltip ที่จะแสดงตอน Hover --- */}
      <div className="absolute bottom-full mb-3 left-1/2 -translate-x-1/2 w-72 bg-gray-900 border border-gray-700 text-gray-200 text-[11px] p-3 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-[100] pointer-events-none">
        <p className="text-yellow-400 font-bold mb-1 text-xs">⚠️ ข้อมูลที่ต้องเตรียมสำหรับการแจ้งปัญหา:</p>
        <ol className="list-decimal pl-4 space-y-1">
          <li>รูปปัญหา</li>
          <li>รายละเอียด</li>
          <li>
            (กรณีมีปัญหาเรื่องพอร์ต) ID พอร์ต 
            <span className="text-gray-400 block mt-1 bg-gray-800 p-1.5 rounded">
              👉 เข้า "พอร์ตของฉัน" ➔ เข้าพอร์ตย่อย ➔ ดูตรง URL แล้ว copy ที่อยู่ด้านหลัง portfolio/ <br/>
              <span className="text-blue-300">เช่น portfolio/PORTdrfC...</span>
            </span>
          </li>
        </ol>
        
        {/* ลูกศรชี้ลงของ Tooltip */}
        <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900"></div>
      </div>

      {/* --- ส่วนของปุ่มหลัก --- */}
      <button
        onClick={handleReportIssue}
        // ปรับแต่งสีตรงนี้: ใช้โทน Rose ไล่ไป Orange เพื่อความซอฟต์
        className="flex items-center justify-center w-full gap-2  text-sm  bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 text-white shadow-lg transform hover:scale-105 transition-transform  font-bold py-2 px-4 rounded-xl  hover:shadow-md  duration-300"
      >
       <svg
          xmlns="http://www.w3.org/2000/svg"
          // ปรับเป็น h-5 w-5 เพื่อให้ใหญ่ขึ้น และเพิ่ม text-black ให้ไอคอนเป็นสีดำ
          className="h-5 w-5 text-black drop-shadow-sm" 
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
        แจ้งปัญหาทาง Mail
      </button>
    </div>
  );
};

export default ReportIssueButton;